/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import { getUser } from '../selectors/userSelectors';
import LocaleContext from '../contexts/LocaleContext';

const useLanguagesSwitch = ({
  language
}) => {
  const [langLoaded, setLangLoaded] = useState(false);
  const {
    langEnabled,
    locale
  } = useSelector(getUser);
  const {
    setLocale
  } = useContext(LocaleContext);
  useEffect(() => {
    setLangLoaded(false);
    const I18nProvider = createStandardI18nProvider();
    I18nProvider.setLocale({
      langEnabled: true,
      locale: language
    });
    Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]).then(() => {
      setLangLoaded(true);
      setLocale(language);
    });
    return () => {
      setLangLoaded(false);
      const resetProvider = createStandardI18nProvider();
      resetProvider.setLocale({
        langEnabled,
        locale
      });
      Promise.all([resetProvider.register(lang), registerAllData(resetProvider)]).then(() => {
        setLangLoaded(true);
        setLocale(locale);
      });
    };
  }, [language, langEnabled, locale, setLangLoaded, setLocale]);
  return langLoaded;
};

export default useLanguagesSwitch;